/**
 * SurveysFeedback
 */
export const SurveysFeedback = (function () {

  let html = {
  /**
   * 
   * @param {*} DOM element of the the survey we are retrieving
   */
   getSurvey : function(element) 
   {
     // Create an object to be outputted
     let survey = [];
 
     // Get all forms
     let forms = element.getElementsByClassName('survey-form');
     // // For all forms
     for (let form of forms) {
         let data = new FormData(form);
         
         let answer = Array.from(data.keys())
         .reduce((result, key) => {
           if (result[key]) {
             result[key] = data.getAll(key)

             // check if the result is an array (if it is we have a checkbox with more than one option checked)
             if (result[key].includes("Other")) {
              let index = result[key].length - 1;
              let questionElement = element.querySelector('#'+key);
              let textarea = questionElement.querySelector('textarea');

              result[key][index] = 'Other: ' + textarea.value;
            }
             return result
           }
           result[key] = data.get(key);

           if (result[key] === 'Other' ) {
            // use the key var to get the id of the question where we can then get text area using querySelector(textarea);
            let questionElement = element.querySelector('#'+key);
            let textarea = questionElement.querySelector('textarea');

            // Update the value with the text content added after ':' delimeter
            result[key] = data.get(key) + ': ' + textarea.value;
          }
           return result;
         }, {});
         // Add to the array if there are any answered questions
         if (Object.keys(answer).length !== 0) {
           survey.push( answer );
         }
     }

     return survey
   }
  }

  let backend = {
    /**
     * GET the survey responses
     * @param {*} url 
     * @returns 
     */
    getSurveyResponses : function(url)
    {
      return $.get(url);
    },
  
    // Post the data to the backend
    postSurvey : function(url, survey) {
      return $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: {
            survey: survey
        },
        headers: {
          'x-csrf-token': Util.getCSRF()
        },
      });
    }
  }
  
  return {
    html : html,
    backend : backend
  }

}());